import { render, staticRenderFns } from "./RenewalClientsData.vue?vue&type=template&id=fca47d28&scoped=true&"
import script from "./RenewalClientsData.vue?vue&type=script&lang=js&"
export * from "./RenewalClientsData.vue?vue&type=script&lang=js&"
import style0 from "./RenewalClientsData.vue?vue&type=style&index=0&id=fca47d28&scoped=true&lang=css&"
import style1 from "./RenewalClientsData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca47d28",
  null
  
)

export default component.exports